function imageSize(src) {
  /* eslint-disable */
  var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  /* esling-enable */

  if (match) {
    return match[1];
  } else {
    return null;
  }
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === 'master') {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + '_' + size + suffix);
  } else {
    return null;
  }
}

const createItem = ({
  product_id,
  variant_id: id,
  id: line_id,
  product_title: title,
  line_price: price,
  options_with_values,
  image,
  url,
  quantity,
  properties,
  line_level_discount_allocations
}, bundleItems, cartItems) => {

  const variantTitle = formatVariant(options_with_values);
  const fidnLineIndex = cartItems.findIndex(item => item.id === line_id && item.properties == properties );
  const lineIndex = fidnLineIndex >= 0 ? fidnLineIndex + 1 : false;
  const propertiesArray = Object.keys(properties).map((key) => [key, properties[key]]);
  const bundleType = propertiesArray.find(item => item[1] === 'Bundle');
  const bundleId = properties["Bundle-Id"];
  const bundleProduct = bundleItems.find(item => item?.properties["_Variant-Id"] == id);
  const bundleLineId = bundleProduct?.id;
  const bundlePrice = bundleProduct?.line_price;
  const bundleFindIndex = cartItems.findIndex(item => item.id == bundleLineId && item.properties == bundleProduct?.properties);
  const bundleLineIndex = bundleFindIndex >= 0 ? bundleFindIndex + 1 : false;
  const bundleProperties = bundleProduct?.properties;
  const propertiesData = propertiesArray.map(item => {if(item[0][0] != '_' && item[0] != 'Bundle-Id') { return `
    <div class="property-item"><span class="property-title">${item[0]}</span><span class="property-value">${item[1]}</span></div>
  `} }).join('');
  
  console.log('from cart drawer', bundleProduct);


  const img = image
    ? getSizedImageUrl(image.replace("." + imageSize(image), ""), "200x")
    : "https://www.placecage.com/200/200"; // todo: replace with different placeholder image

  // View this as cart-item.liquid - basically. -ae 06.22.19
  return `
    <drawer-item class='cart-drawer__item ' ${lineIndex?`data-line-index=${lineIndex}`:``} ${bundleLineId?`data-bundle-line-id=${bundleLineId}`:``} ${bundleLineIndex?`data-bundle-line-index=${bundleLineIndex}`:``} ${bundleId?`data-bundle-variant-id=${bundleId}`:``} data-properites=${JSON.stringify(properties)} ${bundleProperties?`data-bundle-properties=${JSON.stringify(bundleProperties)}`:``}  data-component='cartDrawerItem' data-pid=${product_id} data-id=${id}>
      <a href='${url}' class="cart-drawer__item-image">
        <img src='${img}' />
      </a>

      <div class='cart-item__details f fdc jcb'>
        <div class='cart-item__header'>
          <div class='cart-item__title'>
            <a href='${url}' class='caps mv0 unstyled-link'>${title}</a>
            <div class='xxsmall sans caps cm mt025 book'>${variantTitle}</div>
          </div>
          <span class='dn'>${formatMoney(price)}</span>
          <div class='cart-item__price'>${removeTrailingZeros(
            formatMoney(price)
          )}</div>
        </div>
        <div class="cart-item_properties ${propertiesArray.length ? '' : 'dn'}">
                ${propertiesData}
        </div>

        <div class='cart-item__tools ${bundleType?'action-disabled':''}'>
          <div class='cart-item__stepper aic f ${
            price === 0 ? "is-disabled" : ""
          }'>
            <div class='cart-stepper js-remove-single'>
              <span class='visually-hidden'>Decrease quantity for ${title}</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus cart-stepper--remove" fill="none" viewBox="0 0 10 2">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
              </svg>
            </div>
            <div class='cart-quantity js-single-quantity'>${quantity}</div>
            <div class='cart-stepper js-add-single'>
              <span class='visually-hidden'>Increase quantity for ${title}</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus cart-stepper--add" fill="none" viewBox="0 0 10 10">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
              </svg>
            </div>
          </div>

          ${!bundleType?`<button class='button--reset button--remove js-remove-item'>Remove</button>`:``}
        </div>
      </div>
    </drawer-item>
`;
};

function renderItems(items) {
  console.log('items from renderItems', items);
  const bundleItems = items.filter((item) => item.properties && item.properties.Type === 'Bundle');

  if (items === undefined) {
    console.log('Can\'t reach cart.js');
    return;
  }
  if (items.length <= 0) return '';

  return items.reduce((accum, item) => (accum += createItem(item, bundleItems, items)), '');
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartDrawerState = {
      open: false,
    };

    this.overlay = this.querySelector('.js-overlay');
    this.closeButton = this.querySelector('.js-close');
    this.subtotal = this.querySelector('.js-subtotal');
    this.currencyCode = this.querySelector('.js-currency-code');
    this.itemsRoot = this.querySelector('.js-cart-drawer-items');
    this.cartDrawer = this.querySelector('.js-cart-drawer');
    this.cartCount = document.querySelectorAll('.js-cart-count');
    this.cartBubble = document.querySelector('.js-cart-bubble');
    this.cartFooter = this.querySelector('.js-cart-footer');
    this.cartEmpty = this.querySelector('.js-cart-empty');
    this.cartEmptyMsg = this.querySelector('.js-empty-message');

    this.cartToggle = document.querySelector('.js-cart-drawer-toggle');

    // this.shippingProgressBar = this.querySelector('.js-shipping-progress-bar');
    // this.shippingProgressMsg = this.querySelector('.js-free-shipping-amount-remaining');
    // this.freeShippingUnmet = this.querySelector('.js-free-shipping-unmet-msg');
    // this.freeShippingMet = this.querySelector('.js-free-shipping-met-msg');
  }

  connectedCallback() {
    // Check initial cart state on load
    fetchCart().then((cart) => {
      if (cart.item_count) {
        this.cartBubble.classList.add("is-active");
      } else {
        this.cartBubble.classList.remove("is-active");
      }
    });
    document.addEventListener('cart:updated', (e) => {
      e.preventDefault();
      console.log('cart update event fired', this.cartCount);

      fetchCart().then((cart) => {
        this.render(cart);
        const bundleProductsCount = cart.items.filter((item) => item.properties && item.properties.Type === 'Bundle').reduce((accum, item) => accum + item.quantity, 0);        

        this.cartCount.forEach((cartCountEl) => {
          console.log('cart.item_count', cart.item_count);
          console.log('cartCountEl coming from', cartCountEl);
          cartCountEl.innerHTML = cart.item_count - bundleProductsCount;
        });

        if (cart.item_count) {
          this.cartBubble.classList.add('is-active');
        } else {
          this.cartBubble.classList.remove('is-active');
        }
      });
    });

    this.cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      fetchCart().then((cart) => {
        this.open(cart);
        this.setActiveElement(document.activeElement);
      });

      this.cartDrawerState.open = true;
    });

    this.overlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.close();

      this.cartDrawerState.open = false;
    });

    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('clicking close!');
      this.close();

      this.cartDrawerState.open = false;
    });
  }

  render = (cart) => {
    this.itemsRoot.innerHTML = renderItems(cart.items);
    // this is using es2020 nullish coalescing operator and may cause issues on older browsers - ae05.30.22
    this.subtotal.innerHTML = removeTrailingZeros(
      formatMoney(cart.total_price)
    );
    this.currencyCode.innerHTML =
      document.querySelector("meta[property='currency-code']")?.content ?? "";

    console.log(cart.items);

    if (cart.items === undefined) {
      this.cartFooter.classList.add("is-hidden");
      this.itemsRoot.classList.add("is-hidden");
      this.cartEmpty.classList.remove("is-hidden");
      this.cartEmptyMsg.classList.add("is-hidden");
    } else if (cart.items.length === 0) {
      // hide items mount point and cart footer if there are no items in the cart
      this.cartFooter.classList.add("is-hidden");
      this.itemsRoot.classList.add("is-hidden");
      this.cartEmpty.classList.remove("is-hidden");
    } else {
      // unhide items mount point and cart footer if there are items in the cart
      this.cartFooter.classList.remove("is-hidden");
      this.itemsRoot.classList.remove("is-hidden");
      this.cartEmpty.classList.add("is-hidden");
    }
  };

  open = (cart) => {
    if (cart === undefined) {
      const err = `Open requires a Cart object to be passed, cart is currently set to ${cart}`;
      throw new Error(err);
    }

    try {
      hideChatWidget();
    } catch (e) {
      console.log('hideChatWidget function undefined or chat widget not present');
    }

    this.classList.remove('is-hidden');
    this.classList.add('is-active');

    this.itemsRoot.innerHTML = this.loading;



    setTimeout(() => {
      this.classList.add('is-visible');
      this.tabIndex = 0;
      this.cartDrawer.tabIndex = 0;
      this.setAttribute('aria-expanded', 'true');
      document.getElementById('root').tabIndex = -1;
      console.log('cart from inside timeout', cart);
      setTimeout(this.render(cart), 10);
      this.cartDrawerState.open = true;

      console.log('cart drawer state is', this.cartDrawerState.open);
    }, 50);

    console.log('drawerOpen');
  };

  close = () => {
    this.classList.remove('is-visible');

    try {
      showChatWidget();
    } catch (e) {
      console.log('showChatWidget function undefined or chat widget not present');
    }

    document.getElementById('root').tabIndex = 0;

    setTimeout(() => {
      this.classList.remove('is-active');
      this.classList.add('is-hidden');
      this.tabIndex = -1;
      this.setAttribute('aria-expanded', 'false');
      this.cartDrawerState.open = false;

      console.log('cart drawer state is', this.cartDrawerState.open);
    }, 400);
  };

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class DrawerItem extends HTMLElement {
  constructor() {
    super();
    console.log('drawer-item, yes');

    this.removeButton = this.querySelector('.js-remove-item');
    this.decrease = this.querySelector('.js-remove-single');
    this.increase = this.querySelector('.js-add-single');
    this.quantityElement = this.querySelector('.js-single-quantity');
    this.qty = parseInt(this.quantityElement.innerHTML);
    this.currentQty = parseInt(this.quantityElement.innerHTML);
    this.id = this.getAttribute('data-id');
    this.lineIndex = this.getAttribute('data-line-index');
    this.properties = this.getAttribute('data-properties') ? 
                       JSON.parse(this.getAttribute('data-properties')) : null;
    this.bundleVariantId = this.getAttribute('data-bundle-variant-id');
    this.bundleLineIndex = this.getAttribute('data-bundle-line-index');
    this.bundleProperties = this.getAttribute('data-bundle-properties') ? 
                            JSON.parse(this.getAttribute('data-bundle-properties')) : null;
  }
  
  connectedCallback() {
    this.removeButton?.addEventListener('click', async (e) => {
      e.preventDefault();
      const cartItems = await fetchCart();
      const quantities = await cartItems.items.map(item => null);
      if(this.bundleVariantId && this.bundleLineIndex){
       quantities[this.lineIndex-1] = 0;
       quantities[this.bundleLineIndex-1] = 0;
       updateMultipleItems(quantities);
      }
      else {
        // quantities[this.lineIndex-1] = 0;
        // updateMultipleItems(quantities);
        removeAddon(this.id, this.properties);
      }
      console.log('selected positions are', quantities);
    });

    this.decrease?.addEventListener('click', async (e) => {
      e.preventDefault();
      const currentQuantity = this.qty - 1;
      const cartItems = await fetchCart();
      const quantities = await cartItems.items.map(item => null);
      if(this.bundleVariantId && this.bundleLineIndex){
        quantities[this.lineIndex-1] = currentQuantity;
        quantities[this.bundleLineIndex-1] = currentQuantity;
        updateMultipleItems(quantities);
       }
      else {
        updateAddon(this.id, parseInt(this.currentQty) - 1, this.properties);
      }
      console.log('selected positions are', quantities);
    });

    this.increase?.addEventListener('click', async (e) => {
      const currentQuantity = this.qty + 1;
      const cartItems = await fetchCart();
      const quantities = await cartItems.items.map(item => null);
      if(this.bundleVariantId && this.bundleLineIndex){
        quantities[this.lineIndex-1] = currentQuantity;
        quantities[this.bundleLineIndex-1] = currentQuantity;
        updateMultipleItems(quantities);
       }
      else {
        updateAddon(this.id, parseInt(this.currentQty) + 1, this.properties);
      }
      console.log('selected positions are', quantities);
    });
  }
}

customElements.define('drawer-item', DrawerItem);
